module.exports = __webpack_public_path__ + "img/08.9e16ff6d.jpg";